import { useLayoutEffect, useMemo, useState } from 'react';

const useScrollLayout = (
  containerRef: React.RefObject<HTMLDivElement>,
  list: any[],
  parentHeight: number
) => {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [rowHeight, setRowHeight] = useState(0);

  const needsScroll = useMemo(() => {
    const estimatedRowHeight = rowHeight || 77; // 각 행의 예상 높이
    const actualHeaderHeight = headerHeight || 38; // 실제 측정된 헤더 높이 또는 기본값
    const estimatedTableHeight =
      (list?.length || 0) * estimatedRowHeight + actualHeaderHeight;

    return estimatedTableHeight > parentHeight - 20; // 여백 최소화
  }, [list?.length, parentHeight, headerHeight, rowHeight]);

  useLayoutEffect(() => {
    const headerElement =
      containerRef.current?.querySelector('.ant-table-thead');
    const rowElement = containerRef.current?.querySelector('.ant-table-row');

    if (rowElement) {
      const actualRowHeight = rowElement.clientHeight;
      setRowHeight(actualRowHeight);
    }

    if (headerElement) {
      const actualHeaderHeight = headerElement.clientHeight;
      setHeaderHeight(actualHeaderHeight);
    }
  }, [containerRef.current]);

  return { headerHeight, needsScroll };
};

export default useScrollLayout;
